
// Libraries
import { Component, Vue, Prop, Emit } from "nuxt-property-decorator";
import { ButtonText } from "~/operations/messages";

// Components
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import SummedRating from "~/components/molecules/display/ratings/SummedRating.vue";

@Component({
  components: {
    RouterLink,
    SummedRating,
  },
})
export default class PartnerRatingOrganism extends Vue {
  @Prop({ default: 0 }) ratingValue: string;
  @Prop({ default: 0 }) ratingCount: string;
  @Prop({ default: 0 }) ratingValueLastYear: string;
  @Prop({ default: 0 }) ratingCountLastYear: string;
  @Prop({ default: { ralCheck: false, tankCheck: false } }) awards: {
    ralCheck: boolean;
  };

  ButtonText = ButtonText;

  @Emit()
  emitPartnerRatingTrue() {
    return true;
  }
}
